import { render, staticRenderFns } from "./ScenarioPreviewSlide.vue?vue&type=template&id=30873862"
import script from "./ScenarioPreviewSlide.vue?vue&type=script&lang=js"
export * from "./ScenarioPreviewSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30873862')) {
      api.createRecord('30873862', component.options)
    } else {
      api.reload('30873862', component.options)
    }
    module.hot.accept("./ScenarioPreviewSlide.vue?vue&type=template&id=30873862", function () {
      api.rerender('30873862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/ScenarioPreviewSlide.vue"
export default component.exports